import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../../layouts/CommonLayout';
import { sendVerificationCode } from '../../../../api/AuthApi';
import { verifyPhoneReverificationCode } from '../../../../api/MemberApi';
import { AlertModal } from '../../../layouts/AlertModal'; // AlertModal import

const PhoneReverificationPage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        phone: '',
        verificationCode: ''
    });
    const [isPhoneVerified, setIsPhoneVerified] = useState(false);
    const [isCodeSent, setIsCodeSent] = useState(false);

    // 모달 상태 관리
    const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

    const getErrorMessage = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        }
        return '오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
    };

    const handleSendCode = async () => {
        if (!formData.phone || formData.phone.length !== 11) {
            setAlertState({ isVisible: true, message: '올바른 휴대폰 번호를 입력해주세요.' });
            return;
        }

        try {
            await sendVerificationCode(formData.phone);
            setAlertState({ isVisible: true, message: '인증번호가 발송되었습니다.' });
            setIsCodeSent(true);
        } catch (error) {
            setAlertState({ isVisible: true, message: getErrorMessage(error) });
        }
    };

    const handleVerifyCode = async () => {
        if (!formData.verificationCode || formData.verificationCode.length !== 6) {
            setAlertState({ isVisible: true, message: '올바른 인증번호를 입력해주세요.' });
            return;
        }

        try {
            await verifyPhoneReverificationCode(formData.phone, formData.verificationCode);
            setAlertState({
                isVisible: true,
                message: '휴대폰 번호 재인증이 완료되었습니다.',
                callback: () => navigate('/app/mypage', { replace: true })
            });
            setIsPhoneVerified(true);
        } catch (error) {
            setAlertState({ isVisible: true, message: getErrorMessage(error) });
        }
    };

    return (
        <CommonLayout title="휴대폰 번호 재인증">
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
            />
            <div className="space-y-4 p-4">
                <div className="text-xl font-bold mb-4">변경하고자 하는 번호로 인증해주세요.</div>
                <div className="text-sm text-gray-600">안전한 서비스 이용을 위해 휴대폰 번호 변경 시 재인증이 필요합니다.</div>

                <div className="h-4"></div>

                <div className="text-sm font-semibold">휴대폰 번호</div>
                <div className="flex space-x-2">
                    <input
                        type="text"
                        placeholder="휴대폰 번호 ( - 없이 입력)"
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                        className={`${isPhoneVerified ? 'w-full border-green-300 bg-green-50' : 'w-3/5 border-gray-300'} px-2 py-3 border rounded-lg`}
                        minLength="11"
                        maxLength="11"
                        disabled={isPhoneVerified}
                    />
                    {!isPhoneVerified && (
                        <button
                            onClick={handleSendCode}
                            className="w-2/5 px-2 py-3 bg-gray-200 text-gray-700 rounded-lg whitespace-nowrap"
                        >
                            {isCodeSent ? '인증번호 재전송' : '인증번호 전송'}
                        </button>
                    )}
                </div>

                <div className="text-sm font-semibold">인증번호</div>
                <div className="flex space-x-2">
                    <input
                        type="text"
                        placeholder="인증번호 6자리"
                        value={formData.verificationCode}
                        onChange={(e) => setFormData({ ...formData, verificationCode: e.target.value })}
                        className={`${isPhoneVerified ? 'w-full border-green-300 bg-green-50' : 'w-3/5 border-gray-300'} px-2 py-3 border rounded-lg`}
                        maxLength="6"
                        disabled={isPhoneVerified}
                    />
                    {!isPhoneVerified && (
                        <button
                            onClick={handleVerifyCode}
                            className="w-2/5 px-2 py-3 bg-amber-500 text-white rounded-lg whitespace-nowrap"
                        >
                            인증하기
                        </button>
                    )}
                </div>

                {isPhoneVerified && (
                    <div className="flex items-center space-x-2 p-4 bg-green-50 border border-green-300 rounded-lg">
                        <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                        <span className="text-green-600 font-medium">휴대폰 번호 재인증이 완료되었습니다.</span>
                    </div>
                )}
            </div>
        </CommonLayout>
    );
};

export default PhoneReverificationPage;
